import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TypedDialogService } from '@libs/src/typed-dialog/typed-dialog.service';

import { EventSubmissionInstructionsDialogComponent } from '@main-client/src/app/events/event-submission-instructions-dialog/event-submission-instructions-dialog.component';

import { EventSubmissionInstructionsDialogResult } from '@main-client/src/app/events/event-submission-instructions-dialog/event-submission-instructions-dialog.types';
import { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

@Injectable()
export class EventSubmissionInstructionsDialogService {
  constructor(private readonly dialog: TypedDialogService) {}

  openDialog(
    opportunity: Opportunity,
    pathwayOptions: { isPathwayPreferences: boolean } = {
      isPathwayPreferences: false,
    },
  ): Observable<EventSubmissionInstructionsDialogResult | ''> {
    return this.dialog
      .open(EventSubmissionInstructionsDialogComponent, {
        data: {
          opportunity,
          isPathwayPreferences: pathwayOptions.isPathwayPreferences,
        },
        disableClose: true,
        maxWidth: '500px',
        width: '95vw',
      })
      .afterClosed();
  }
}
